import React, { Fragment } from "react";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import AboutSection from "../../components/about/about";
import ModulesGrid from "../../components/ModulesGrid/ModulesGrid";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import ContactSection from "../../components/ContactSection/ContactSection";
import TestimonialSection from "../../components/Testimonial/Testimonial";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import FeaturesAndBrands from "../../components/FeatureSection/FeatureSection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";

// Site-wide SoftwareApplication graph. Previously emitted from public/index.html on
// EVERY page, which duplicated the per-page SoftwareApplication on all 20 /feature/*
// pages. It belongs on exactly one page — the homepage.
const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Axoix",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "description": "AI-powered business operating system with 22 modules, 22 AI characters, 19 industry verticals, and voice control in 81 languages.",
    "url": "https://axoix.com",
    "image": "https://axoix.com/og-image.png",
    "author": {
      "@type": "Organization",
      "name": "Axoix Technologies Private Limited"
    },
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "INR",
      "lowPrice": "0",
      "highPrice": "7500",
      "offerCount": "4",
      "offers": [
        {
          "@type": "Offer",
          "name": "Explorer Plan",
          "price": "0",
          "priceCurrency": "INR",
          "description": "Free forever - 5 employees, 1 company, 1 vertical, SEAL e-sign, REMEDY complaints"
        },
        {
          "@type": "Offer",
          "name": "Officer Plan",
          "price": "1500",
          "priceCurrency": "INR",
          "description": "20 employees, 2 companies, 2 verticals, 22 AI characters, 81 languages"
        },
        {
          "@type": "Offer",
          "name": "Commander Plan",
          "price": "3600",
          "priceCurrency": "INR",
          "description": "50 employees, 6 companies, 5 verticals, priority support, API access"
        },
        {
          "@type": "Offer",
          "name": "Titan Plan",
          "price": "7500",
          "priceCurrency": "INR",
          "description": "Enterprise plan - 100 employees, 10 companies, all addons, white-label"
        }
      ]
    },
    "featureList": "AI Costing Engine, SEAL E-Signatures, REMEDY Complaint Management, CHORUS Social Media, Sales CRM, LINK Business Phone, Website Builder, Team Chat, UPI Payment Collection, HR Management, Accounting, Inventory"
  };

const HomePage: React.FC = () => {
  return (
    <Fragment>
        <SEO title="AI-Powered Business Operating System" description="AXOIX is an AI-powered business operating system with 22 AI characters, 19 industry verticals, and voice control in 81 languages. Free forever plan available." path="/" schema={softwareSchema} />
        <div className='ai-agency'>
          <div className="body_wrap o-clip">
            <Header />
            <main>
              <HeroSection/>
              <AboutSection/>
              {/* <section className="pt-100 pb-60">
                <div className="container">
                  <div className="sec-title sec-title--two text-center mb-50">
                    <h2 className="title">Explore Our Modules</h2>
                    <p className="mt-15 opacity-75">18 AI-powered modules — click any to learn more</p>
                  </div>
                  <ModulesGrid limit={6} showViewAll />
                </div>
              </section> */}
              <ServiceSection/>
              {/* <FeaturesAndBrands/> */}
              <IndustriesMarqueeSection/>
              <IndustriesSection limit={8} showViewAll />
              <FeatureSection/>
              {/* <TestimonialSection/> */}
              <ContactSection/>
            </main>
            <Footer />
            <Scrollbar />
          </div>
        </div>
    </Fragment>
  );
};

export default HomePage;
